module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/员工关怀.fa56f248.png";